import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyStructure } from "../../../redux/actions/structure";
import { sortByPtBR } from "../../../helper/sortHelper";
import "./ManagersFilters.scss";

const LEVEL_OPTIONS = [
  { value: "ADMIN", label: "Administrador" },
  { value: "COORDINATOR", label: "Coordenador" },
  { value: "MANAGER", label: "Gerente" },
];

const ManagersFilters = ({ filters, onChange, onReset }) => {
  const dispatch = useDispatch();
  const structure = useSelector((state) => state?.structure);

  const [nameInput, setNameInput] = useState(filters.name || "");
  const [emailInput, setEmailInput] = useState(filters.email || "");

  useEffect(() => {
    dispatch(getCompanyStructure());
  }, [dispatch]);

  useEffect(() => {
    setNameInput(filters.name || "");
  }, [filters.name]);

  useEffect(() => {
    setEmailInput(filters.email || "");
  }, [filters.email]);

  useEffect(() => {
    const trimmed = nameInput.trim();
    if (trimmed === (filters.name || "")) return;
    const handle = setTimeout(() => {
      onChange({ name: trimmed || undefined });
    }, 350);
    return () => clearTimeout(handle);
  }, [nameInput, filters.name, onChange]);

  useEffect(() => {
    const trimmed = emailInput.trim();
    if (trimmed === (filters.email || "")) return;
    const handle = setTimeout(() => {
      onChange({ email: trimmed || undefined });
    }, 350);
    return () => clearTimeout(handle);
  }, [emailInput, filters.email, onChange]);

  const units = useMemo(() => {
    if (!Array.isArray(structure?.data)) return [];
    return sortByPtBR(structure.data.map((unit) => unit.name).filter(Boolean));
  }, [structure?.data]);

  const handleUnitChange = (event) => {
    const value = event.target.value;
    onChange({ unit: value || undefined });
  };

  const handleLevelChange = (event) => {
    const value = event.target.value;
    onChange({ level: value || undefined });
  };

  const hasActiveFilter = Boolean(
    filters.name || filters.email || filters.unit || filters.level
  );

  return (
    <div className="ManagersFilters">
      <div className="filters-grid">
        <div className="filter-field">
          <label>Nome</label>
          <input
            type="text"
            placeholder="Buscar por nome..."
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
          />
        </div>

        <div className="filter-field">
          <label>E-mail</label>
          <input
            type="text"
            placeholder="Buscar por e-mail..."
            value={emailInput}
            onChange={(e) => setEmailInput(e.target.value)}
          />
        </div>

        <div className="filter-field">
          <label>Área</label>
          <div className="select-wrapper">
            <select value={filters.unit || ""} onChange={handleUnitChange}>
              <option value="">Todas as áreas</option>
              {units.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
            <span className="weui--arrow-outlined" />
          </div>
        </div>

        <div className="filter-field">
          <label>Perfil de acesso</label>
          <div className="select-wrapper">
            <select value={filters.level || ""} onChange={handleLevelChange}>
              <option value="">Todos os perfis</option>
              {LEVEL_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <span className="weui--arrow-outlined" />
          </div>
        </div>

        <button
          type="button"
          className="filters-reset"
          onClick={onReset}
          disabled={!hasActiveFilter}
        >
          Limpar filtros
        </button>
      </div>
    </div>
  );
};

export default ManagersFilters;
